import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { environment } from './../../environments/environment';
import { Employee } from '../models/Employee';

@Injectable()
export class EmployeeService {
  constructor(private http: Http) { }

  selectedId: number = -1;

  get selected(): number {
    return this.selectedId;
  }
  set selected(id: number) {
    this.selectedId = id;
  }

  search(opt) {
    return this.http.post(environment.server.url + '/employee/search', opt)
      .map(response => response.json())
  }

  getEmployee(idemployee: number) {
    console.log('getEmployee', idemployee)
    return this.http.post(environment.server.url + '/employee/find-one', { idemployee: idemployee })
      .map(response => response.json())
  }

  persist(employee: Employee) {
    return this.http.post(environment.server.url + '/employee/persist', { wmodel: employee })
      .map(response => response.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/services/employee.service.ts